import styled, { keyframes } from 'styled-components';
import Button from '@nebula/button';

export const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 0px;
  width: 100%;
  gap: 16px;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    gap: 24px;
    width: fit-content;
    flex-direction: row-reverse;
  }
`;

export const ActionButton = styled(Button)`
  width: 100%;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: ${({ buttonKind }) => (buttonKind === 'primaryMagenta' ? '208px' : 'fit-content')};
  }

  ${({ buttonKind, isWebview, theme }) =>
    buttonKind === 'secondaryMagenta' &&
    isWebview &&
    `
    color: ${theme.color.decorative.magenta[70]} !important;
    border-color: ${theme.color.decorative.magenta[70]} !important;
    `}
`;

const spin = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.span`
  display: none;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  background-color: transparent;
  border: 0.125rem solid rgba(255, 255, 255, 0.25);
  border-top-color: ${({ theme }) => theme.color.ui.white};
  border-radius: ${({ theme }) => theme.borderRadius.circle.rem};
  animation: ${spin} 0.75s infinite linear;
  @media ${({ theme }) => theme.media.shouldAnimate} {
    display: flex;
  }
`;
export const ApplePayOption = styled.div`
  ${({ disabled }) => disabled && 'pointer-events: none;'};
  width: 100%;
  apple-pay-button {
    --apple-pay-button-width: 100%;
    --apple-pay-button-height: 3rem;
    --apple-pay-button-padding: 0.5rem 1rem;
    --apple-pay-button-border-radius: 0.375rem;
    --apple-pay-button-box-sizing: border-box;
    @media ${({ theme }) => theme.media.smallDesktopMin} {
      --apple-pay-button-width: 23rem;
    }
  }
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: 208px;
  }
  @media ${({ theme }) => theme.media.smallDesktopMin} {
    width: 220px;
  }
`;

export const GooglePayOption = styled.div`
  ${({ disabled }) => disabled && 'pointer-events: none;'};
  width: 100%;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: 208px;
  }
  @media ${({ theme }) => theme.media.smallDesktopMin} {
    width: 220px;
  }
`;
